import { useTranslation } from 'react-i18next';
import { ReactComponent as SparkleIcon } from './sparkle.svg';
import { ReactComponent as BetaCloseIcon } from '../../../../assets/xcross-icon.svg';
import { ParcelItemsAiBetaPanelContainer } from './styles';

interface Props {
  onDismiss: () => void;
}

const ParcelItemsAiBetaPanel = ({ onDismiss }: Props) => {
  const { t } = useTranslation();

  return (
    <ParcelItemsAiBetaPanelContainer className='ai-beta-panel'>
      <span className='ai-beta-tag'>{t('parcel_items_ai_beta')}</span>
      <button
        type='button'
        className='ai-beta-close'
        aria-label={t('parcel_items_ai_dismiss_beta')}
        onClick={onDismiss}>
        <BetaCloseIcon aria-hidden='true' />
      </button>
      <h3>
        <span
          className='sparkle-icon'
          aria-hidden='true'>
          <SparkleIcon />
        </span>
        {t('parcel_items_ai_title')}
      </h3>
      <p>{t('parcel_items_ai_sidebar_description')}</p>
    </ParcelItemsAiBetaPanelContainer>
  );
};

export default ParcelItemsAiBetaPanel;
